export enum AssociationType {
  Normal = 'normal',
  Special = 'special',
}
